import React from "react";
import clsx from "classnames";
import Loader from "./Loader";

const Button = ({
  loading,
  disabled,
  text,
  onClick,
  className,
  type = "button",
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={loading || disabled}
    className={clsx(
      "mt-8 py-3 px-24 md:py-[17px] md:min-w-[409.34px] h-[56px] bg-pw-blue text-white hover:bg-cyan-500 rounded-3xl",
      { "opacity-[0.7]": loading || disabled },
      { "cursor-not-allowed": disabled },
      className
    )}
  >
    {loading ? <Loader /> : text}
  </button>
);

export default Button;
